export default "__VITE_ASSET__3Ehz53gv__"